module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.svg";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.svg
// module id = 1236
// module chunks = 11